import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const Header = () => {
  const [username, setUsername] = useState('');
  const [userid, setUserid] = useState(''); // Changed to a string, not an array
  const [menuPermissions, setMenuPermissions] = useState([]);
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Fetch the username and userid from localStorage on component mount
  useEffect(() => {
    const storedUsername = localStorage.getItem('userName');
    const storedUserid = localStorage.getItem('userID');
    setUsername(storedUsername);
    setUserid(storedUserid);
    console.log("H", storedUserid);
  }, []);

  // Fetch user permissions from the API
  useEffect(() => {
    if (!userid) return; // Don't call the API if userid is not available

    const fetchPermissions = async () => {
      try {
        const response = await fetch(
          `https://webcore.hunzagroupofindustries.com.pk/api/account/GetPer?userId=${userid}` // Corrected URL
        );
        console.log('Response Status:', response.status);
        if (response.ok) {
          const data = await response.json();
          console.log('Fetched Data:', data); // Log the entire response object
          setMenuPermissions(data.permissions || []); // Set permissions from the API response
        } else {
          console.error('Failed to fetch permissions. Status:', response.status);
          setMenuPermissions([]); // Fallback to empty permissions
        }
      } catch (error) {
        console.error('Error fetching permissions:', error);
        setMenuPermissions([]);
      }
    };

    fetchPermissions();
  }, [userid]); // Run this effect when the userid changes

  const handleLogout = () => {
    localStorage.clear();
    logout();
    navigate('/login');
  };

  return (
    <Navbar bg="light" expand="lg" className="shadow-sm px-4">
      <Navbar.Brand href="/">HSML</Navbar.Brand>
      <Navbar.Toggle aria-controls="navbar-nav" />
      <Navbar.Collapse id="navbar-nav">
        <Nav className="me-auto">
          {/* Conditionally render menu links based on API permissions */}
          {menuPermissions.map((permission, index) => {
            if (permission.CanRead === 1) { // Check if user has permission to read this location
              let locationPath = '';
              switch (permission.Location) {
                case 'Unit I':
                  locationPath = '/#/screenI';
                  break;
                case 'Unit II':
                  locationPath = '/#/screen';
                  break;
                // Add more cases for different locations if needed
                default:
                  locationPath = '/'; // Default path if no match
              }

              return (
                <Nav.Link key={index} href={locationPath}>
                  {permission.Location} {/* Display the location name */}
                </Nav.Link>
              );
            }
            return null; // Return null if the user doesn't have permission for this location
          })}
        </Nav>

        <Dropdown align="end">
          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
            <i className="bi bi-person-circle"></i> {username}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item href="#/profile">Profile</Dropdown.Item>
            <Dropdown.Item href="#/settings">Settings</Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
